import React, { useState } from 'react'
import { View, ViewStyle, TextStyle } from 'react-native'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import { dualOptionModalProps } from './dual-option-modal.props'
import { Button } from '../button'
import { Text } from '../text'
import { color, spacing } from '../../theme'

export function DualOptionModal(props: dualOptionModalProps) {
  const { title, showModal, setShowModal, modalMessage, continueHandler, yesBtnText, yesBtnColor } =
    props

  const [showSecondModalFlag, setShowSecondModalFlag] = useState<boolean>(false)

  const continueToSecondModal = () => {
    continueHandler()
    setShowSecondModalFlag(true)
  }

  const resetAndCloseModal = () => {
    setShowModal(false)
    //Note: SetTimeout hides unwanted content while modal closes.
    setTimeout(() => {
      setShowSecondModalFlag(false)
    }, 1000)
  }

  return (
    <View>
      <Dialog maxWidth="xs" aria-labelledby="confirmation-dialog-title" open={showModal}>
        <div style={DIALOG_TITLE_CONTAINER}>
          <Text style={{ fontSize: 18, fontWeight: 'bold' }} tx={title} />
        </div>

        <DialogContent style={DIALOG_CONTENT}>
          <Text
            style={{ fontSize: 14, lineHeight: 16, fontWeight: '400', textAlign: 'center' }}
            tx={modalMessage}
          />
        </DialogContent>
        <DialogActions style={DIALOG_BUTTON_CONTAINER}>
          {showSecondModalFlag ? (
            <Button
              accessibilityRole="button"
              accessibilityLabel="Confirm"
              style={{
                borderRadius: 15,
                padding: 25,
                backgroundColor: color.white,
                borderColor: color.black,
                borderWidth: 0.5,
              }}
              onPress={() => resetAndCloseModal()}
            >
              <Text tx="Common.done" />
            </Button>
          ) : (
            <>
              <Button
                accessibilityRole="button"
                accessibilityLabel="Confirm"
                style={{
                  borderRadius: 15,
                  padding: 25,
                  backgroundColor: color.white,
                  borderColor: color.black,
                  borderWidth: 0.5,
                }}
                onPress={() => setShowModal(false)}
              >
                <Text tx="Common.cancel" />
              </Button>
              <Button
                accessibilityRole="button"
                accessibilityLabel="Confirm"
                style={{ borderRadius: 15, padding: 25, backgroundColor: yesBtnColor }}
                onPress={() => continueToSecondModal()}
              >
                <Text style={{ color: color.white, fontWeight: '700' }} tx={yesBtnText} />
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </View>
  )
}

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = {
  paddingTop: 40,
  backgroundColor: color.white,
  paddingRight: 40,
  paddingLeft: 40,
}
const HEADER: TextStyle = { paddingLeft: 120, paddingRight: 120, fontSize: 24, color: color.black }
const PROFILE_CONTAINER: ViewStyle = {
  marginTop: 20,
  marginBottom: spacing[7],
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center',
}
const LOADER_CONTAINER: ViewStyle = {
  height: 100,
  width: 100,
  flexDirection: 'column',
  justifyContent: 'center',
  marginVertical: 16.5,
}
const USER_CONTAINER: ViewStyle = {
  alignItems: 'center',
  flexDirection: 'column',
  alignSelf: 'center',
  justifyContent: 'center',
}

const DIALOG_TITLE_CONTAINER: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 20,
  paddingTop: 25,
  paddingBottom: 25,
}

const DIALOG_BUTTON_CONTAINER: React.CSSProperties = {
  display: 'flex',
  color: color.white,
  justifyContent: 'center',
  margin: 20,
  marginBottom: 25,
}
const BODY_TEXT_WRAPPER: React.CSSProperties = {
  maxHeight: 500,
  paddingRight: 10,
  overflowY: 'auto',
  textAlign: 'left',
  fontSize: 15,
  letterSpacing: 0.3,
}
const DIALOG_CONTENT: React.CSSProperties = {
  paddingLeft: 30,
  paddingRight: 30,
}
